module.exports = __webpack_public_path__ + "img/001.feb5de4f.png";